import React, { createContext, useState, useContext, useEffect } from "react";

const CourseProgressContext = createContext();

export const moduleRoutes = [
  { path: "/why-it-matters", id: "why-it-matters", name: "Why It Matters" },
  {
    path: "/climate-engine",
    id: "climate-engine",
    name: "How Climate Engine Works",
  },
  {
    path: "/carbon-emissions-101",
    id: "carbon-emissions-101",
    name: "Carbon Emissions 101",
  },
  { path: "/uae-carbon-day", id: "uae-carbon-day", name: "Make It Visible" },
  { path: "/case-studies", id: "case-studies", name: "Case Studies" },
  {
    path: "/carbon-footprint",
    id: "carbon-footprint",
    name: "Carbon Footprint 101",
  },
  { path: "/quiz", id: "quiz", name: "Quiz & Mini-Games" },
  { path: "/action-toolkit", id: "action-toolkit", name: "Action Toolkit" },
  {
    path: "/further-learning",
    id: "further-learning",
    name: "Further Learning",
  },
];

export const CourseProgressProvider = ({ children }) => {
  const [completedModules, setCompletedModules] = useState({});

  // Load completed modules from localStorage on component mount
  useEffect(() => {
    const savedProgress = localStorage.getItem("courseProgress");
    if (savedProgress) {
      try {
        setCompletedModules(JSON.parse(savedProgress));
      } catch (e) {
        console.error("Failed to parse saved progress:", e);
        localStorage.removeItem("courseProgress");
      }
    }
  }, []);

  // Save to localStorage whenever completedModules changes
  useEffect(() => {
    localStorage.setItem("courseProgress", JSON.stringify(completedModules));
  }, [completedModules]);

  // Mark a module as complete or incomplete
  const toggleModuleComplete = (moduleId, isComplete = true) => {
    setCompletedModules((prev) => ({
      ...prev,
      [moduleId]: isComplete,
    }));
  };

  // Check if a module is completed
  const isModuleCompleted = (moduleId) => {
    return !!completedModules[moduleId];
  };

  // Get the total progress percentage
  const getProgressPercentage = () => {
    const completedCount =
      Object.values(completedModules).filter(Boolean).length;
    return (completedCount / moduleRoutes.length) * 100;
  };

  // Get module index and total for progress display
  const getModuleIndex = (currentPath) => {
    const moduleIndex = moduleRoutes.findIndex(
      (module) => module.path === currentPath
    );
    return {
      current: moduleIndex >= 0 ? moduleIndex + 1 : null,
      total: moduleRoutes.length,
    };
  };

  return (
    <CourseProgressContext.Provider
      value={{
        completedModules,
        toggleModuleComplete,
        isModuleCompleted,
        getProgressPercentage,
        getModuleIndex,
        moduleRoutes,
      }}
    >
      {children}
    </CourseProgressContext.Provider>
  );
};

export const useCourseProgress = () => useContext(CourseProgressContext);

export default CourseProgressContext;
